import type { Theme } from "../types/Theme";
import {
    MODERN_FILE_UPLOAD_BORDER_INTERACTIVE,
    MODERN_FILE_UPLOAD_FOREGROUND_COLOR,
} from "./fileUploadThemeTokens";
import {
    MODERN_GRID_ROW_BORDER_COLOR,
    MODERN_GRID_ROW_HOVER_BACKGROUND,
    MODERN_GRID_SUBHEADER_MUTED,
} from "./gridThemeTokens";
import {
    resolveModernCompactFocusBoxShadow,
    shouldUseModernTheme,
} from "./navigationButtonThemeColors";

export type SignatureSizeType = "Small" | "Medium" | "Large" | "Full";

export const MODERN_SIGNATURE_HINT_PADDING_PX = 16;
export const MODERN_SIGNATURE_HINT_GAP_PX = 8;
export const MODERN_SIGNATURE_BASELINE_MARGIN_TOP_PX = 8;
export const MODERN_SIGNATURE_CLEAR_INSET_PX = 8;
export const MODERN_SIGNATURE_ICON_SIZE_PX = 20;
export const MODERN_SIGNATURE_CLEAR_ICON_SIZE_PX = 16;
export const MODERN_SIGNATURE_CLEAR_BUTTON_SIZE_PX = 28;

export function useModernSignatureStyles(theme: Theme): boolean {
    return shouldUseModernTheme(theme);
}

export function resolveModernSignatureBorderColor(): string {
    return MODERN_GRID_ROW_BORDER_COLOR;
}

export function resolveModernSignatureStrokeColor(_theme: Theme): string {
    return MODERN_FILE_UPLOAD_FOREGROUND_COLOR;
}

export function resolveModernSignatureHintColor(): string {
    return MODERN_GRID_SUBHEADER_MUTED;
}

export function resolveModernSignatureBaselineColor(): string {
    return MODERN_FILE_UPLOAD_BORDER_INTERACTIVE;
}

export function resolveModernSignatureClearHoverBackground(): string {
    return MODERN_GRID_ROW_HOVER_BACKGROUND;
}

export function resolveModernSignatureClearIconColor(theme: Theme): string {
    return resolveModernSignatureStrokeColor(theme);
}

export function resolveModernSignatureClearFocusBoxShadow(theme: Theme): string {
    return resolveModernCompactFocusBoxShadow(theme);
}

export function resolveModernSignatureHintFontSize(theme: Theme): string {
    return theme.TextFontSize || `${theme.BaseFontSize ?? 16}px`;
}
